import { Module } from '../Module';

export interface ILoginInScope extends ng.IScope {
  showSigningIn: boolean;
}

Module.instance().directive('tbSigningIn', <any[]>[
  '$interval',
  ($interval: ng.IIntervalService) => {
    return {
      restrict: 'E',
      replace: true,
      scope: {},
      templateUrl: 'signingIn.html',
      link: (scope: ILoginInScope, element: JQuery, attributes: ng.IAttributes) => {
        scope.showSigningIn = false;
        // Display the "Signing in" after a small delay
        $interval(() => scope.showSigningIn = true, 1000, 1);
      }
    };
  }
]);
